export default "__VITE_ASSET__D1YsK6pk__"